var _ellipse, _path, _ellipse2, _path2, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveMapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.255,
    cy: 164.579,
    rx: 122.508,
    ry: 120.579,
    fill: "#B2BFCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.723 401.705C243.983 410.941 230.858 411.16 225.802 402.087L133.025 235.611C128.243 227.03 134.336 216.454 144.156 216.29L323.924 213.29C333.744 213.126 340.198 223.493 335.714 232.229L248.723 401.705Z",
    fill: "#B2BFCA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.718,
    cy: 165.311,
    rx: 95.6456,
    ry: 98.3109,
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.274 362.017C241.048 368.643 231.667 368.806 228.225 362.297L149.843 214.056C146.706 208.123 150.939 200.962 157.652 200.845L309.482 198.199C316.195 198.082 320.662 205.092 317.722 211.131L244.274 362.017Z",
    fill: "#F5F5F5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.771,
    cy: 157.43,
    rx: 40.6745,
    ry: 40.0341,
    fill: "#B2BFCA"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235,
    cy: 156.5,
    rx: 28,
    ry: 27.5,
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMapIcon);
export default __webpack_public_path__ + "static/media/inactive-map-icon.e917c9c8.svg";
export { ForwardRef as ReactComponent };